'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.VCounter = undefined;

var _VCounter = require('./VCounter');

var _VCounter2 = _interopRequireDefault(_VCounter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_VCounter2.default.install = function install(Vue) {
    Vue.component(_VCounter2.default.name, _VCounter2.default);
};
exports.VCounter = _VCounter2.default;
exports.default = _VCounter2.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/vuetify/es5/components/VCounter/index.js
// module id = D6TD
// module chunks = 3 4 5 6 7 8 9